import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

/**
 * Confirms removing an affiliate partner or a campaign. Both are soft deletes, so the
 * sales that were attributed keep their codes and nothing is lost from the sale documents
 * themselves - only the campaign that reads them stops being listed.
 */
function AffiliateDeleteDialog({ open, name, type, onCancel, onConfirm, working }) {
  const isCampaign = type === 'campaign'

  return (
    <Dialog open={open} onClose={onCancel} maxWidth='sm' fullWidth>
      <DialogTitle>{isCampaign ? 'Poistetaanko kampanja?' : 'Poistetaanko kumppani?'}</DialogTitle>
      <DialogContent>
        <Typography variant='body1' gutterBottom>
          <b>{name || ''}</b>
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          {isCampaign
            ? 'Kampanja poistuu listalta eikä sen raporttia pääse enää katsomaan. Myynteihin merkityt koodit jäävät paikoilleen, joten mitään myyntitietoa ei katoa.'
            : 'Kumppani poistuu listalta. Sen kampanjat jäävät voimaan, joten päätä ne erikseen jos myynnin pitää loppua.'}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={working}>
          Peruuta
        </Button>
        <Button onClick={onConfirm} variant='contained' color='error' disabled={working}>
          {working ? 'Poistetaan...' : 'Poista'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AffiliateDeleteDialog
